import { LegacyQuotePagesPath } from 'app/home/common/services/legacy/quote-pages';
import { type QuoteFormMappingKey, quoteFormLegacyPaths } from 'app/home/create-quote/form-config/quote-form-legacy-paths';

/**
 * **********************************************
 * MAP LEGACY PATH TO FORM KEY
 * Reverse lookup over `quoteFormLegacyPaths`, which mirrors the legacy path each form
 * declares via the QuoteFormContextDecorator.
 * **********************************************
 */
export function mapLegacyPathToFormKey(legacyPath: LegacyQuotePagesPath): QuoteFormMappingKey | undefined {
  if (!legacyPath) {
    return undefined;
  }

  const entry = Object.entries(quoteFormLegacyPaths).find(([, path]) => path === legacyPath);

  return entry ? (entry[0] as QuoteFormMappingKey) : undefined;
}
